// modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClarityModule } from 'clarity-angular';
import { AppRoutingModule } from './app-routing/app-routing.module';

// components
import { AppComponent } from './app.component';
import { OverviewComponent } from './overview/overview.component';
import { DetailsComponent } from './details/details.component';
import { LoginComponent } from './login/login.component';
import { AddArticleComponent } from './add-article/add-article.component';
import { ModalComponent } from './modal/modal.component';
import { AlertComponent } from './alert/alert.component';
import { NavigationComponent } from './navigation/navigation.component';
import { HomeComponent } from './home/home.component';
import { UserManagerComponent } from './user-manager/user-manager.component';
import { CreateUserModalComponent } from './create-user-modal/create-user-modal.component';
import { ArticleFilterComponent } from './article-filter/article-filter.component';

// services
import { ArticleService } from './article/article.service';
import { UserService } from "./user/user.service";
import { FilterService } from "./filter/filter.service";

// pipes
import { SearchFilterPipe } from './filter/search-filter.pipe';
import { MainCategoryFilterPipe } from './filter/main-category-filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    OverviewComponent,
    DetailsComponent,
    LoginComponent,
    AddArticleComponent,
    ModalComponent,
    AlertComponent,
    NavigationComponent,
    HomeComponent,
    UserManagerComponent,
    CreateUserModalComponent,
    ArticleFilterComponent,
    SearchFilterPipe,
    MainCategoryFilterPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ClarityModule
  ],
  providers: [
    ArticleService,
    UserService,
    FilterService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts